import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

interface BrandLogoProps {
  /** スクロール時に縮小するコンパクト表示 */
  compact?: boolean;
  /** フッターなど背景が濃い場所向け */
  tone?: "default" | "inverse";
  withEnglish?: boolean;
  className?: string;
}

/**
 * ユメサーチのロゴ。
 * 虫眼鏡＋きらめき（星）の組み合わせをアイコンフォントで表現し、
 * 文字主体のシンプルなロゴにしている。
 */
export default function BrandLogo({
  compact = false,
  tone = "default",
  withEnglish = true,
  className = "",
}: BrandLogoProps) {
  const inverse = tone === "inverse";

  return (
    <Link
      to="/"
      aria-label={`${BRAND.name} トップページ`}
      className={`group flex shrink-0 items-center gap-2.5 ${className}`}
    >
      <span
        className={`brand-gradient relative flex items-center justify-center rounded-lg text-background-50 transition-all ${
          compact ? "h-8 w-8 text-[15px]" : "h-9 w-9 text-base md:h-10 md:w-10 md:text-lg"
        }`}
        aria-hidden="true"
      >
        <i className="ri-search-line" />
        <i className="ri-star-fill absolute -right-0.5 -top-0.5 text-[9px] text-accent-200" />
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading font-bold tracking-[0.02em] ${
            compact ? "text-[16px] md:text-[17px]" : "text-[17px] md:text-[19px]"
          } ${inverse ? "text-background-50" : "text-foreground-950"}`}
        >
          {BRAND.name}
        </span>
        {withEnglish ? (
          <span
            className={`mt-1 hidden text-[9px] font-medium tracking-[0.28em] sm:block ${
              inverse ? "text-background-300" : "text-foreground-500"
            }`}
          >
            {BRAND.nameEn}
          </span>
        ) : (
          <span className="sr-only">{BRAND.nameEn}</span>
        )}
      </span>
    </Link>
  );
}